import { borderRadius, color, padding } from '@evrekadev/evreka-ui-components'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

export const List: React.FC<PropsWithChildren> = ({ children }) => {
  return <ListStyled>{children}</ListStyled>
}

const ListStyled = styled.div`
  ${padding([8])}
  ${borderRadius(8)}
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid ${color('grey200')};

  & > * {
    border-bottom: 1px solid ${color('grey200')};
  }

  & > *:last-child {
    border-bottom: none;
  }
`
